






















































































































































































































































































































































import {
  Component,
  Vue,
  Watch,
  Prop,
  Emit,
} from 'vue-property-decorator';
import moment from 'moment';
import AuthConnector from '@/connector/Auth.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import AffiliateService from '@/services/AffiliateService';
import BaseSnackbar from '@/components/BaseSnackbar.vue';
import ProfileConnector from '@/connector/Profile.vue';
import DialogConnector from '@/connector/Dialog.vue';

const affiliateService = new AffiliateService();

@Component({
  components: {
    AuthConnector,
    BaseDataTable,
    BaseSnackbar,
    ProfileConnector,
    DialogConnector,
  },
})
export default class AffiliateDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public date: string = `${moment().week()}-${moment().year()}`;

  public share: any = {};

  public claimLoading: boolean = false;

  shareUrl() {
    // eslint-disable-next-line no-underscore-dangle
    if (this.share._id) {
      // eslint-disable-next-line no-underscore-dangle
      return `${process.env.VUE_APP_API_ENDPOINT}/shares/detail/me`;
    }
    return `${process.env.VUE_APP_API_ENDPOINT}`;
  }

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  // eslint-disable-next-line class-methods-use-this
  get currentHost() {
    return window.location.host;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  get weekOptions() {
    const current = moment();
    const maximumData = moment().subtract(8, 'week');
    const options = [];
    while (current > maximumData) {
      options.push(`${current.week()}-${current.year()}`);
      current.subtract(1, 'week');
    }
    return options;
  }

  // eslint-disable-next-line class-methods-use-this
  public async copyRefCode() {
    const textToCopy = ((this.$refs.refCode as Vue).$el as HTMLInputElement).querySelector('input');
    if (textToCopy) {
      textToCopy.select();
      document.execCommand('copy');
      this.$store.commit('Snackbar/showNotification', { message: 'คัดลอกลิงค์แนะนำแล้ว', error: false });
    }
  }

  @Watch('date')
  async onDateChange() {
    await this.getShare();
  }

  async getShare() {
    const { data } = await affiliateService.getShare(this.date);
    this.share = { ...data };
  }

  async claimShare() {
    try {
      this.claimLoading = true;
      // eslint-disable-next-line no-underscore-dangle
      const { data } = await affiliateService.cliamShare(this.share._id);
      this.share = { ...data };
      this.$store.commit('Snackbar/showNotification', { message: 'ถอนเงินสำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.claimLoading = false;
  }

  async created() {
    await this.getShare();
  }
}
